import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthContext } from 'src/contexts';
import { useHttp, useNotification } from 'src/common/hooks';
import { LoadingSpinner } from 'src/common/components/loading-spinner/LoadingSpinner';

export function HandleSignup() {
  const { loginWithRedirect, accessToken } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const notify = useNotification();
  const memberId = searchParams.get('id');
  const [isInvited, setIsInvited] = useState(false);
  const { sendRequest: checkInvite, error: errorCheckInvite } = useHttp();
  const [email, setEmail] = useState<string>();
  const { sendRequest: decryptEmail, error: errorDecryptingEmail } = useHttp();

  useEffect(() => {
    if (errorCheckInvite) {
      notify(errorCheckInvite, 'error');
    }

    if (errorDecryptingEmail) {
      notify(errorDecryptingEmail, 'error');
    }
  }, [errorCheckInvite, errorDecryptingEmail]);

  const handleCheckInvite = (email: string) => {
    checkInvite(
      {
        url: `invites/${email}`,
        method: 'GET',
        accessToken,
      },
      (data: any) => {
        if (data) setIsInvited(true);
      },
    );
  };

  useEffect(() => {
    if (!memberId) return;

    decryptEmail(
      {
        url: `invites/decrypt/${memberId}`,
        method: 'GET',
        accessToken,
      },
      email => {
        if (email) {
          setEmail(email as string);
          handleCheckInvite(email as string);
        }
      },
    );
  }, [memberId]);

  useEffect(() => {
    if (isInvited && email) {
      loginWithRedirect({
        appState: { returnTo: '/signup' },
        screen_hint: 'signup',
        login_hint: email,
      });
    }
  }, [isInvited]);

  return <LoadingSpinner />;
}
